import React from "react";
import {
  MerchantDashboardIcon,
  MerchantOutletsIcon,
  MerchantSettingsIcon,
  MerchantSettlementsIcon,
  MerchantTransactionsIcon,
} from "../components/MerchantIcons";
import { formatMerchantTruncatedNumber } from "./merchantLegacyUtils";

export const merchantNavItems = [
  { key: "dashboard", permission: "dashboard", label: "Dashboard", title: "Dashboard", path: "/dashboard", icon: MerchantDashboardIcon },
  { key: "transactions", permission: "transactions", label: "Transactions", title: "Transactions", path: "/transactions", icon: MerchantTransactionsIcon },
  { key: "settlements", permission: "settlements", label: "Settlements", title: "Settlements", path: "/settlements", icon: MerchantSettlementsIcon },
  { key: "outlets", permission: "outlets", label: "Outlets", title: "Outlets", path: "/outlets", icon: MerchantOutletsIcon },
  { key: "settings", permission: "settings", label: "Settings", title: "Settings", path: "/settings", icon: MerchantSettingsIcon },
];

export const merchantPortalMeta = {
  companyName: "Merchant Account",
  shortName: "Merchant Account",
  accountId: "",
  avatar: "ME",
  periodLabel: "Current Period",
  footer:
    "© 2026 Uniweb Pte. Ltd. · Licensed Payment Institution (Singapore) · MAS PS20200612",
  systemStatus: "v2.5.0 · All systems operational",
};

export const merchantDashboardKpis = [];
export const merchantDailyTrend = [];
export const merchantPaymentSections = [];
export const merchantCountryData = [];
export const merchantRecentTransactions = [];
export const merchantTopOutlets = [];
export const merchantAllOutlets = [];
export const merchantSettlements = [];
export const merchantReportCards = [];
export const merchantReportHistory = [];
export const merchantUsers = [];
export const merchantAuditLogs = [];
export const merchantSettingsColumns = [];

export function formatMerchantCurrency(value, digits) {
  return "$" + formatMerchantTruncatedNumber(value, digits, "0.00");
}

export function formatMerchantCompactCurrency(value) {
  return formatMerchantCurrency(value, 2);
}

export function renderMerchantMeta(kpi) {
  return (
    <React.Fragment>
      <span className={"merchant-badge " + kpi.metaBadge}>{kpi.metaLabel}</span>
      {kpi.metaText}
    </React.Fragment>
  );
}
